import React from "react";
import { all, put, select, takeEvery } from "redux-saga/effects";

import { analyticsStoreEvent } from "@/mk2/actions";
import {
    IS_SOLD_POLL_NO,
    IS_SOLD_POLL_YES,
    IsSoldPollYesAction,
} from "@/mk2/apps/bazaar/containers/IsSoldPoll/IsSoldPoll.actions";
import { ProductEntity, ProductSchema } from "@/mk2/apps/bazaar/schemas";
import { XHRAction } from "@/mk2/helpers/api";
import { getLogger } from "@/mk2/logger";
import { getDenormalizedEntity } from "@/mk2/selectors";

const logger = getLogger("bazaar/IsSoldPoll.sagas");

function* yes({ xhr, productId }: IsSoldPollYesAction & XHRAction) {
    // For now just send event to an_events
    const product: ProductEntity = yield select(getDenormalizedEntity, ProductSchema, productId);
    yield put(
        analyticsStoreEvent("is_sold_poll", {
            is_sold: true,
            product_id: product.id,
            price: product.price,
        }),
    );
}

function* no({ xhr, productId }: IsSoldPollYesAction & XHRAction) {
    // For now just send event to an_events
    const product: ProductEntity = yield select(getDenormalizedEntity, ProductSchema, productId);
    yield put(
        analyticsStoreEvent("is_sold_poll", {
            is_sold: false,
            product_id: product.id,
            price: product.price,
        }),
    );
}

export default function* root() {
    yield all([takeEvery(IS_SOLD_POLL_YES, yes), takeEvery(IS_SOLD_POLL_NO, no)]);
}
